import { connect } from "react-redux";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../redux/ApplicationState";
import { IResetPassword } from "../../models/User";
import ResetPassword from "../components/ResetPassword";
import { postResetPassword } from "../../actions/UserAction";
import { resetStates } from "../../actions/Common";

const mapStateToProps = ({
  registerUserState,
  resetPassState,
}: ApplicationState) => ({
  registerUserState: registerUserState,
  resetPassState: resetPassState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, Action<any>>
) => {
  return {
    postResetPassword: (payload: IResetPassword, headers: any) => {
      dispatch(postResetPassword(payload, headers));
    },
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
